import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Placement } from '../../Components/designConstants';
import { CLIENT_COLUMN_HEADERS } from './cps-utils';

const SurveyTableHeaders = () => (
  <div className='cps-survey-headers'>
    <div className='cps-survey-header-cell cps-header-client'>Client</div>
    <div className='cps-survey-header-cell cps-header-relationship'>Relationship</div>
    {CLIENT_COLUMN_HEADERS.map(header => (
      <OverlayTrigger
        key={header.key}
        placement={Placement.TOP}
        overlay={
          <Tooltip id={`tooltip-${header.key}`}>
            <strong>{header.label}</strong>
            <br />
            {header.tooltip}
          </Tooltip>
        }
      >
        <div className='cps-survey-header-cell cps-header-time'>{header.label}</div>
      </OverlayTrigger>
    ))}
    <div className='cps-survey-header-cell cps-header-total'>Total</div>
    <div className='cps-survey-header-cell cps-header-actions' />
  </div>
);

export { SurveyTableHeaders };
